
<div class="header">
  <div class="picker">
    <div class="row">
      <h5>Start Month:</h5>
      <date-picker [pickedDate]="startDate" [byMonth]="true" (onDateChange)="changeDate($event)"></date-picker>
      <h5>Summary Tax Type:</h5>
      <dropdown 
        [selections]="summaryTaxTypes" 
        [selected]="summaryTaxTypes | findById: summaryTaxType"
        (select)="updateSummaryTaxType($event)"
      ></dropdown>
    </div>

    <div class="hint">12 months of data will be shown, with budgets falling into the month of their events' start date.  Cash flow dates are determined by all budgets' billing and payment schedules that have dates in a given month.</div>
  </div>
  <action-button (click)="export()" [text]="'Export'"></action-button>
</div>

<simple-grid 
  [ngClass]="{ closed: !revenueOpen }"
  [closed]="!revenueOpen" 
  [startClosed]="false"
  [data]="monthlySummaries" 
  [columns]="columns" 
  [rows]="revenueRows" 
  [title]="'REVENUE'"
  (toggle)="revenueOpen = !revenueOpen"
></simple-grid>

<simple-grid 
  [ngClass]="{ closed: !costOpen }"
  [closed]="!costOpen" 
  [startClosed]="true"
  [data]="monthlySummaries" 
  [columns]="columns" 
  [rows]="costRows" 
  [title]="'COSTS'"
  (toggle)="costOpen = !costOpen"
></simple-grid>

<simple-grid 
  [ngClass]="{ closed: !summaryOpen }"
  [closed]="!summaryOpen" 
  [startClosed]="true"
  [data]="monthlySummaries" 
  [columns]="columns" 
  [rows]="summaryRows" 
  [title]="'SUMMARY'"
  (toggle)="summaryOpen = !summaryOpen"
></simple-grid>

<simple-grid 
  [ngClass]="{ closed: !cashFlowOpen }"
  [closed]="!cashFlowOpen" 
  [startClosed]="true"
  [data]="monthlySummaries" 
  [columns]="columns" 
  [rows]="cashFlowRows" 
  [title]="'CASH FLOW'"
  (toggle)="cashFlowOpen = !cashFlowOpen"
></simple-grid>
